<template>
  <section>

    <v-dialog
      v-model="warningDialog"
      max-width="500">
      <v-card>
        <v-card-title class="headline">Atenção</v-card-title>

        <v-card-text>
          Deseja Remover Porte do Estudo Ambiental? Essa ação não poderá ser desfeita.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error darken-2"
            flat
            @click="warningDialog = false">
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-2"
            flat
            @click="remove()"
          >
            Prosseguir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn flat icon>
      <v-icon small @click="warningDialog = true">mdi-delete</v-icon>
    </v-btn>
  </section>
</template>

<script>
import TypologySizeService from '@/services/applications/configurations/TypologySizeService';

export default {
  name: 'RemoveTypologySize',
  components: {},
  props: ['typologySize', 'typology'],
  data() {
    return {
      warningDialog: false,
    };
  },
  methods: {
    remove() {
      const vm = this;
      this.$store.dispatch('setLoadingDialog', true);
      TypologySizeService
        .destroy(vm.typology.id, vm.typologySize.id)
        .then(() => {
          vm.$swal({
            title: 'Estudo Ambiental Removido com Sucesso',
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            vm.warningDialog = false;
            vm.typology.typology_sizes.forEach((item, index) => {
              if (item.id === vm.typologySize.id) {
                vm.typology.typology_sizes.splice(index, 1);
              }
            });
          });
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
